// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n/index'
import App from './App'
import { captureInviteParamsFromUrl } from '@/lib/invite'

// Capture invite deep-link params (`?email=&orgSlug=`) BEFORE React/the router
// mounts — the / → /dashboard → /login redirect chain would otherwise strip the
// query string before LoginPage can read it.
captureInviteParamsFromUrl()

const root = document.getElementById('root')
if (!root) throw new Error('root element not found')
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
